export default __webpack_public_path__ + "static/media/transEnd.01a29199.jpg";